import React from 'react';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Text from '@amzn/meridian/text';

/**
 * Static placeholder for the Standard Operating Procedure section on the
 * Work Item Detail Page. Issues no network calls and renders the
 * "SOP" header plus a "content not yet available" placeholder message.
 */
const SopSection: React.FC = () => {
    return (
        <Column spacing="300">
            <Heading level={2}>SOP</Heading>
            <Text type="b200" data-testid="sop-placeholder">
                Standard Operating Procedure content is not yet available.
            </Text>
        </Column>
    );
};

export default SopSection;
